/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-11-26 09:20:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-29 18:54:30
 */
import router from '@/router';
import axios from 'axios';
import { $getToken } from '@/utils';
import { Message } from 'element-ui';

const requests = axios.create({
  withCredentials: true,
  timeout: 15000,
  // 旧接口路径已包含 /api。这里继续用当前站点，避免再拼一次 apiBaseURL。
  baseURL: `${window.location.origin}/`,
});

requests.interceptors.request.use(
  config => {
    const token = $getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

requests.interceptors.response.use(res => res, err => {
  // silentError 仅关闭公共重复提示；错误仍 reject，权限页面自行区分 409／403／503。
  if (!(err.config && err.config.silentError)) {
    const response = err.response;
    const status = response && response.status;
    const message = response && response.data && response.data.message;
    switch (status) {
      case 401:
        Message.error('登录过期'); router.replace('/login'); break;
      case 403:
        Message.error(message || '没有操作权限'); break;
      case 409:
        Message.error(message || '数据已变化，请刷新后再操作'); break;
      case 429:
        Message.error('操作频繁'); break;
      case 500:
        Message.error('服务器错误'); break;
      case 504:
        Message.error('请求超时'); break;
      default:
        Message.error(message || (response ? '请求失败' : '网络连接失败')); break;
    }
  }
  return Promise.reject(err);
});

export default requests;
